module.exports = __webpack_public_path__ + "img/gift-fill.81d544c7.svg";